
export default function TelegramSection() {
  const benefits = [
    "Keine neue App oder Registrierung nötig",
    "Sofort startklar, mobil oder am Desktop",
    "100% anonym, sicher und vertraulich – deine Chats bleiben privat",
    "Antwortet in Sekunden, wann immer du willst",
    "Ideal für Menschen, die wenig Zeit, aber große Ziele haben"
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-8">
              Erstmals als Telegram-Version – weil echte Veränderung einfach sein darf
            </h2>
            
            <p className="text-xl text-gray-600 mb-8">
              Mindshift AI funktioniert direkt in deinem vertrauten Messenger:
            </p>
            
            <div className="space-y-4">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start">
                  <div className="w-6 h-6 bg-teal-500 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <p className="text-gray-700 text-lg">{benefit}</p>
                </div>
              ))}
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/3853aace1bc553bc55f89485a25a34dc.jpg"
              alt="Person interagiert positiv überrascht mit Mindshift AI auf Telegram"
              className="w-full max-w-md mx-auto rounded-2xl shadow-2xl object-top"
            />
            
            {/* Decorative elements */}
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-gradient-to-br from-teal-400 to-blue-500 rounded-full opacity-20"></div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gradient-to-br from-blue-400 to-teal-500 rounded-full opacity-15"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
